module.exports = __webpack_public_path__ + "img/t1-y1.cf1305a2.gif";